import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Radio,
  Row,
  notification,
  Checkbox,
} from "antd";
import { useState, useEffect } from "react";
import API_SERVICE from "shared/services/api-service";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "../../../index.scss";
import "./InvoicingDetails.scss";
import {
  GSTIN_REGEX,
  TDS_REGEX,
  SACCODE_REGEX,
  PINCODE_REGAX,
  PAN_REGAX,
} from "shared/constants/AppConstants";
import { RootState } from "shared/redux/store";
import { useSelector } from "react-redux";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import OIButton from "shared/ComponentsOI/OIButton/OIButton";
import { debounce } from "lodash";

interface IInvoicingDetails {
  connectorDetails: any;
  setConnector: any;
}

const InvoicingDetails: React.FunctionComponent<IInvoicingDetails> = (
  props: IInvoicingDetails
) => {
  const { connectorDetails } = props;

  const { id } = useParams() as any;
  const history = useHistory();

  const { appColors }: any = useSelector((state: RootState) => state.common);
  const { tenantInfo } = useSelector((state: RootState) => state.tenant);

  const [tdsForm] = Form.useForm();

  const [defaultBilling, setDefaultBilling] = useState() as any;
  const [selectedAddress, setSelectedAddress] = useState([]) as any;
  const [tdsType, setTdsType] = useState(false);
  const [selectedGSTMode, setSelectedGSTMode] = useState<string[]>([]);
  const [gstNotApplicable, setGstNotApplicable] = useState(false);
  const [isShowFullDetails, setIshowFullDetails] = useState(false);
  const [eInvoiceApplicable, setEInvoiceApplicable] = useState(false);
  const btnStylePrimary: any = { "--custColor": appColors?.appPrimaryColor };
  const btnStyleSecondary: any = {
    "--custColor": appColors?.appSecondaryColor,
  };
  const customStylesRadio: any = {
    "--bgColor": appColors?.appSecondaryColor ?? "",
  };

  useEffect(() => {
    if (!id) {
      history.goBack();
    }
  }, [id]);

  const invoicingConfig = connectorDetails?.invoicingConfig;
  const gstDetails = invoicingConfig?.gstDetails;
  const serviceProviderDetails = invoicingConfig?.serviceProviderDetails;
  const address = serviceProviderDetails?.address;
  const billingAddress =
    tenantInfo?.tenantInvoicingConfig?.billingDetails?.billingAddress;

  useEffect(() => {
    let defaultBillingAddress =
      Array.isArray(billingAddress) && billingAddress.length > 0
        ? billingAddress.find((address) => address.defaultAddress) ||
          billingAddress[0]
        : null;
    let connectorBillingAddress =
      invoicingConfig === null ? "" : invoicingConfig?.billingDetails;
    const selectedBillingAddress =
      connectorBillingAddress != defaultBillingAddress &&
      connectorBillingAddress?.length > 0
        ? connectorBillingAddress
        : defaultBillingAddress;
    setDefaultBilling(selectedBillingAddress);
    if (invoicingConfig !== null) {
      setEInvoiceApplicable(gstDetails?.electronicInvoicingEnabled);
      setGstNotApplicable(!gstDetails?.gstDetailsApplicable);
      setTdsType(invoicingConfig?.tdsDetails?.tdsEnabled);
      tdsForm.setFieldsValue({
        gstIn: gstDetails?.gstin ?? "",
        eInvoicingApplicable: gstDetails?.electronicInvoicingEnabled ?? "",
        sacCode: gstDetails?.sacCode ?? "",
        gstMode: gstDetails?.gstModes ?? "",
        gstNotApplicable: !(gstDetails?.gstDetailsApplicable ?? ""),
        tdsRate: invoicingConfig?.tdsDetails?.tdsRate ?? "",
        tdsEnabled: invoicingConfig?.tdsDetails?.tdsEnabled ? "Yes" : "No",
        billTo: tenantInfo?.tenantInvoicingConfig?.billingDetails?.billTo,
        connectorName: serviceProviderDetails?.name ?? "",
        connectorAddress: address?.address ?? "",
        connectorPincode: address?.pinCode ?? "",
        connectorCity: address?.city ?? "",
        connectorState: address?.state ?? "",
        connectorPAN: serviceProviderDetails?.pan ?? "",
      });
    } else {
      tdsForm.setFieldsValue({
        billTo: tenantInfo?.tenantInvoicingConfig?.billingDetails?.billTo,
        connectorName: connectorDetails?.basicDetails?.name ?? "",
        connectorAddress:
          connectorDetails?.kycDetails?.currentAddress?.address ?? "",
        connectorPincode:
          connectorDetails?.kycDetails?.currentAddress?.pinCode ?? "",
        connectorCity: connectorDetails?.kycDetails?.currentAddress?.city ?? "",
        connectorState:
          connectorDetails?.kycDetails?.currentAddress?.state ?? "",
        connectorPAN: connectorDetails?.kycDetails?.pan ?? "",
      });
    }
    //setGstNotApplicable((gstDetails?.gstin?.length ?? 0) == 0);
    setSelectedGSTMode(gstDetails?.gstModes ?? "");
  }, []);

  useEffect(() => {
    tdsForm.setFieldsValue({ gstMode: selectedGSTMode });
  }, [selectedGSTMode]);

  const buildPayload = (formData: any) => {
    let billToAddress =
      selectedAddress.length === 0 ? defaultBilling : selectedAddress;
    const payload = {
      basicDetails: {
        ...connectorDetails?.basicDetails,
        gstIn: formData?.gstIn,
        gender:
          connectorDetails?.basicDetails?.gender === "Male"
            ? "M"
            : connectorDetails?.basicDetails?.gender === "Female"
            ? "F"
            : "O",
      },
      accounts: null,
      kycDetails: null,
      otherDetails: null,
      invoicingConfig: {
        tdsDetails: {
          tdsEnabled: formData?.tdsEnabled === "Yes",
          tdsRate: formData?.tdsRate,
        },
        gstDetails: {
          gstin: formData?.gstIn,
          gstModes:
            (formData?.gstMode?.length ?? 0) == 0
              ? undefined
              : formData?.gstMode,
          sacCode: formData?.sacCode,
          electronicInvoicingEnabled: eInvoiceApplicable,
          gstDetailsApplicable: !gstNotApplicable,
        },
        billingDetails: {
          gstin: billToAddress?.gstin,
          addressLine: billToAddress?.addressLine,
          city: billToAddress?.city,
          state: billToAddress?.state,
          pincode: billToAddress?.pincode,
        },
        serviceProviderDetails: {
          name: formData?.connectorName,
          address: {
            address: formData?.connectorAddress,
            city: formData?.connectorCity,
            state: formData?.connectorState,
            pinCode: formData?.connectorPincode,
          },
          pan: formData?.connectorPAN,
        },
      },
    };
    return payload;
  };

  const onFinish = (values: any) => {
    const tdsEnabled = values?.tdsEnabled === "Yes";
    if (
      invoicingConfig?.tdsDetails?.tdsEnabled !== tdsEnabled ||
      invoicingConfig?.tdsDetails?.tdsRate !== values?.tdsRate ||
      gstDetails?.gstMode !== values?.gstMode ||
      gstDetails?.sacCode !== values?.sacCode ||
      gstDetails?.gstIn !== values?.gstIn ||
      gstDetails?.electronicInvoicingEnabled !==
        values?.electronicInvoicingEnabled ||
      invoicingConfig?.billingDetails?.address !== values?.billingAddress ||
      serviceProviderDetails?.name !== values?.connectorName ||
      address?.address !== values?.connectorAddress ||
      address?.city !== values?.connectorCity ||
      address?.pinCode !== values?.connectorPincode ||
      address?.state !== values?.connectorState ||
      address?.pan !== values?.connectorPAN
    ) {
      const payload = buildPayload(values);
      API_SERVICE.updateConnector(id, payload)
        .then(({ data }) => {
          if (data) {
            props.setConnector(data?.payload);
            notification.success({ message: "Connector Updated Successfully" });
            history.push("/connectors");
          }
        })
        .catch((e: any) => {
          notification.error({ message: API_SERVICE.handleErrors(e) });
        });
    } else {
      notification.error({ message: "No Changes Found" });
    }
  };

  const handleGstInChange = (e) => {
    if (e?.target.value?.length === 0) {
      setGstNotApplicable(true);
      setSelectedGSTMode([]);
      tdsForm.setFieldsValue({ sacCode: "" });
    } else {
      setGstNotApplicable(false);
    }
  };

  const handleNotApplicableChange = (e) => {
    setGstNotApplicable(!gstNotApplicable);
  };

  const checkPincode = (e: any) => {
    const { value: nextValue } = e.target;
    const params = {
        pin_code: nextValue,
    };
    API_SERVICE.checkPincode(params).then(({ data }) => {
        if (data) {
            tdsForm.setFieldsValue({
              connectorCity: data.payload.city,
              connectorState: data.payload.state,
            });
        }
    });
  };

  const renderAddress = (address: any) => {
    return (
      <div
        className="billing-address-view"
        onClick={() => {
          setDefaultBilling(address);
          setSelectedAddress(address);
          setIshowFullDetails(false);
        }}
      >
        <div>GSTIN: {address?.gstin}</div>
        <div>{address?.addressLine}</div>
        <div>{`${address?.city}, ${address?.state}, ${address?.pincode}`}</div>
      </div>
    );
  };

  const getBillToAddress = () => {
    let otherBillingAddress = billingAddress?.filter((address) => {
      return (
        address?.gstin !== defaultBilling?.gstin ||
        address?.city !== defaultBilling?.city ||
        address?.state !== defaultBilling?.state ||
        address?.pincode !== defaultBilling?.pincode ||
        address?.addressLine !== defaultBilling?.addressLine
      );
    });
    return otherBillingAddress;
  };

  return (
    <div className="main-container">
      <div
        style={{
          backgroundColor: "#396EF614",
          color: "#273896C4",
          marginTop: "20px",
          paddingBlock: "5px",
          paddingInline: "10px",
          borderRadius: "8px",
          textAlign: "center",
        }}
      >
        All the listed data points are mandatory for successful invoice
        generation for this connector. Please ensure all required data points
        are configured before proceeding.
      </div>
      <Form layout="vertical" onFinish={onFinish} form={tdsForm}>
        <Row
          gutter={[24, 24]}
          className="main-row"
          style={{ paddingTop: "10px" }}
        >
          <Col
            xs={24}
            sm={24}
            md={12}
            xl={8}
            span={8}
            className="left-container"
          >
            <Divider orientation="left" orientationMargin="0">
              <b> TDS</b>
            </Divider>
            <Form.Item name="tdsEnabled">
              <Radio.Group
                className="invoice-radio"
                style={customStylesRadio}
                defaultValue="No"
                onChange={(e) => {
                  setTdsType(e.target.value === "Yes");
                  tdsForm.resetFields(["tdsRate"]);
                }}
              >
                <Radio value="Yes">Yes</Radio>
                <Radio value="No">No</Radio>
              </Radio.Group>
            </Form.Item>
            <div className="form-group">
              <Form.Item
                className="field-bg"
                style={{ width: "100%" }}
                name="tdsRate"
                label="TDS Rate %"
                rules={[
                  {
                    required: tdsType,
                    pattern: TDS_REGEX,
                    message: "Please enter valid TDS Rate",
                  },
                ]}
              >
                <Input
                  type="number"
                  className="custom-input"
                  placeholder="Enter TDS Rate%"
                  disabled={!tdsType}
                />
              </Form.Item>
              <Divider orientation="left" orientationMargin="0">
                <b> GST Details</b>
              </Divider>
              <Form.Item
                className="field-bg"
                style={{ width: "100%" }}
                name="gstIn"
                label="GSTIN"
                rules={[
                  {
                    pattern: GSTIN_REGEX,
                    message: "Invaid GSTIN provided, please enter again",
                  },
                ]}
              >
                <Input
                  className="custom-input"
                  placeholder="Enter GSTIN"
                  onChange={handleGstInChange}
                />
              </Form.Item>
              <Form.Item name="gstNotApplicable">
                <Checkbox
                  disabled={!gstNotApplicable}
                  checked={gstNotApplicable}
                  className="gst-checkbox"
                  onChange={handleNotApplicableChange}
                >
                  Not Applicable
                </Checkbox>
              </Form.Item>
              <Form.Item
                className="field-bg"
                style={{ width: "100%" }}
                name="gstMode"
                label="GST Mode"
                rules={[
                  {
                    required: !gstNotApplicable,
                    message: "Please select at least one GST Mode!",
                  },
                ]}
                valuePropName="value"
              >
                <Checkbox.Group
                  className="gst-checkbox-group"
                  value={selectedGSTMode}
                  disabled={gstNotApplicable}
                >
                  <Checkbox
                    className="gst-checkbox"
                    value="IGST"
                    onChange={(e) => {
                      setSelectedGSTMode([]);
                      if (e.target.checked) {
                        setSelectedGSTMode(["IGST"]);
                      }
                    }}
                  >
                    IGST
                  </Checkbox>
                  <Checkbox
                    className="gst-checkbox"
                    value="CGST"
                    onChange={(e) => {
                      setSelectedGSTMode([]);
                      if (e.target.checked) {
                        setSelectedGSTMode(["CGST", "SGST"]);
                      }
                    }}
                  >
                    CGST
                  </Checkbox>
                  <Checkbox
                    className="gst-checkbox"
                    value="SGST"
                    onChange={(e) => {
                      setSelectedGSTMode([]);
                      if (e.target.checked) {
                        setSelectedGSTMode(["CGST", "SGST"]);
                      }
                    }}
                  >
                    SGST
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
              <Divider orientation="left" orientationMargin="0">
                <b> SAC Code</b>
              </Divider>
              <Form.Item
                className="field-bg"
                style={{ width: "100%" }}
                name="sacCode"
                label="SAC Code"
                rules={[
                  {
                    required: !gstNotApplicable,
                    message: "Please enter SAC Code",
                  },
                  {
                    validator: (_, value) => {
                      if (!value || SACCODE_REGEX.test(value)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Please enter a valid 4-8 digit SAC Code")
                      );
                    },
                  },
                ]}
              >
                <Input
                  className="custom-input"
                  placeholder="Enter SAC Code"
                  disabled={gstNotApplicable}
                />
              </Form.Item>
              <Form.Item name="electronicInvoicingEnabled">
                <Checkbox
                  disabled={gstNotApplicable}
                  checked={eInvoiceApplicable}
                  className="gst-checkbox"
                  onChange={(event) =>
                    setEInvoiceApplicable(event.target.checked)
                  }
                >
                  Is E-invoicing Applicable ?
                </Checkbox>
              </Form.Item>
              <Divider orientation="left" orientationMargin="0">
                <b> Billing Details</b>
              </Divider>
              <Form.Item
                className="field-bg"
                style={{ width: "100%" }}
                name="billTo"
                label="Bill To"
              >
                <Input className="custom-input" name="Bill To" readOnly />
              </Form.Item>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ marginBottom: "5px" }}>Billing Address</div>
                  <Button
                    type="text"
                    size="small"
                    className="details-icons"
                    onClick={() => setIshowFullDetails(!isShowFullDetails)}
                  >
                    {isShowFullDetails ? <UpOutlined /> : <DownOutlined />}
                  </Button>
                </div>
                {defaultBilling && renderAddress(defaultBilling)}
                {isShowFullDetails &&
                  getBillToAddress()?.map((address) => renderAddress(address))}
              </div>
            </div>
          </Col>
          <Divider
            className="custome-devider-hozntl"
            type="vertical"
            style={{ height: "auto" }}
          />
          <Col
            xs={24}
            sm={24}
            md={11}
            xl={8}
            span={8}
            className="left-container"
          >
            <Divider orientation="left" orientationMargin="0">
              <b> Connector (Service Provider) Details</b>
            </Divider>
            <div style={{ marginBottom: "5px" }}>Name</div>
            <Form.Item
              className="field-bg"
              style={{ width: "100%" }}
              name="connectorName"
              label="Name"
              rules={[
                {
                  required: serviceProviderDetails?.name,
                  message: "Please enter Name",
                },
              ]}
            >
              <Input className="custom-input" placeholder="Enter Name" />
            </Form.Item>
            <div style={{ marginBottom: "5px" }}>Address</div>
            <Form.Item
              className="field-bg"
              style={{ width: "100%" }}
              name="connectorAddress"
              label="Address"
              rules={[
                {
                  required: address?.address,
                  message: "Please enter Address",
                },
              ]}
            >
              <Input className="custom-input" placeholder="Enter Address" />
            </Form.Item>
            <Form.Item
              className="field-bg"
              style={{ width: "100%" }}
              name="connectorPincode"
              label="Pincode"
              rules={[
                {
                  required: address?.pinCode,
                  pattern: PINCODE_REGAX,
                  message: "Please enter valid Pincode",
                },
              ]}
            >
              <Input 
                className="custom-input" 
                placeholder="Enter Pincode" 
                onChange={debounce(checkPincode, 1000)}
              />
            </Form.Item>
            <Form.Item
              className="field-bg"
              style={{ width: "100%" }}
              name="connectorCity"
              label="City"
              rules={[
                {
                  required: address?.city,
                  message: "Please enter City",
                },
              ]}
            >
              <Input className="custom-input" placeholder="Enter City" />
            </Form.Item>
            <Form.Item
              className="field-bg"
              style={{ width: "100%" }}
              name="connectorState"
              label="State"
              rules={[
                {
                  required: address?.state,
                  message: "Please enter State",
                },
              ]}
            >
              <Input className="custom-input" placeholder="Enter State" />
            </Form.Item>
            <div style={{ marginBottom: "5px" }}>PAN</div>
            <Form.Item
              className="field-bg"
              style={{ width: "100%" }}
              name="connectorPAN"
              label="PAN"
              rules={[
                {
                  pattern: PAN_REGAX,
                  message: "Please enter valid PAN",
                },
              ]}
            >
              <Input
                className="custom-input"
                placeholder="Enter PAN"
                readOnly={(serviceProviderDetails?.pan?.length ?? 0) != 0}
              />
            </Form.Item>
          </Col>
        </Row>

        <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
          <Form.Item>
            <OIButton
              label="Cancel"
              style={btnStyleSecondary}
              onClick={() => history.push("/connectors")}
            />
          </Form.Item>
          <Form.Item>
            <OIButton
              label="Save"
              style={btnStylePrimary}
              type="primary"
              htmlType="submit"
            />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default InvoicingDetails;
